import data from '../../data/product'
import types from './types'

const initialState = {
  checkoutSummary: {},
  paymentIntent: {},
  piDirectCheckout: {},
  orderPlacedData: {},
  sendOrderPlace: {},
  cartPageData: {},
  providerCheckout: {},
  providerPlaceOrder: {},
  providerOrderInfo: {},
  subscriptionCheckoutPage: {},
  fetchSubscriptionPI: {},
  paymentUpdateResp: {},
  membershipPaymentDetail: {},
  productPaymentDetail: {},
  providerPaymentDetail: {},
  subscribedData: {},
  subscriptionReceipt: {},
  preSubscriptionReceiptInfo: {},
  changeSubscriptionPlan: {},
  fetchProductPI: {},
  providerSubCheckoutPage: {},
  coachOrServiceIdData: {},
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  console.log(action.type)
  switch (action.type) {
    case types.CHECKOUT_SUMMARY_RESPONSE:
      // console.log(action.payload)
      return {
        ...state,
        checkoutSummary: action.payload
      }
    case types.CHECKOUT_SUMMARY_CLEAR:
      return {
        ...state,
        checkoutSummary: {}
      }
    case types.PAYMENT_INTENT_RESPONSE:
      // console.log(action.payload)
      return {
        ...state,
        paymentIntent: action.payload
      }
    case types.PAYMENT_INTENT_CLEAR:
      return {
        ...state,
        paymentIntent: {}
      }
    case types.PI_DIRECT_CHECKOUT_RESPONSE:
      // console.log(action.payload)
      return {
        ...state,
        piDirectCheckout: action.payload
      }
    case types.PI_DIRECT_CHECKOUT_CLEAR:
      return {
        ...state,
        piDirectCheckout: {}
      }
    case types.SEND_ORDER_PLACE_RESPONSE:
    case types.ZERO_SEND_ORDER_PLACE_RESPONSE:
      // console.log(action.payload)
      return {
        ...state,
        sendOrderPlace: action.payload
      }
    case types.SEND_ORDER_PLACE_CLEAR:
    case types.ZERO_SEND_ORDER_PLACE_CLEAR:
      return {
        ...state,
        sendOrderPlace: {}
      }
    case types.ORDER_PLACED_RESPONSE:
      // console.log(action.payload)
      return {
        ...state,
        orderPlacedData: action.payload
      }
    case types.ORDER_PLACED_CLEAR:
      return {
        ...state,
        orderPlacedData: {}
      }
    case types.CART_PAGE_DATA_RESPONSE:
      // console.log(action.payload)
      return {
        ...state,
        cartPageData: action.payload
      }
    case types.CART_PAGE_DATA_CLEAR:
      return {
        ...state,
        cartPageData: {}
      }
    case types.PROVIDER_CHECKOUT_RESPONSE:
      // console.log(action.payload)
      return {
        ...state,
        providerCheckout: action.payload
      }
    case types.PROVIDER_CHECKOUT_CLEAR:
      return {
        ...state,
        providerCheckout: {}
      }
    case types.PROVIDER_PLACEORDER_RESPONSE:
      console.log(action.payload)
      return {
        ...state,
        providerPlaceOrder: action.payload
      }
    case types.PROVIDER_PLACEORDER_CLEAR:
      console.log('PROVIDER CLEAR PLACE ORDER')
      return {
        ...state,
        providerPlaceOrder: {}
      }

    case types.PROVIDER_PLACEORDER_V2_RESPONSE:
      console.log(action.payload)
      return {
        ...state,
        providerOrderInfo: action.payload
      }
    case types.PROVIDER_PLACEORDER_V2_CLEAR:
      console.log('PROVIDER CLEAR PLACE ORDER')
      return {
        ...state,
        providerOrderInfo: {}
      }

    case types.SUBSCRIPTION_CHECKOUT_PAGE:
      return {
        ...state,
        subscriptionCheckoutPage: action.payload
      }

    case types.SUBSCRIPTION_CHECKOUT_PAGE_CLEAR:
      return {
        ...state,
        subscriptionCheckoutPage: {}
      }

    case types.FETCH_SUBSCRIPTION_PI_RES:
      return {
        ...state,
        fetchSubscriptionPI: action.payload
      }

    case types.FETCH_SUBSCRIPTION_PI_CLEAR:
      return {
        ...state,
        fetchSubscriptionPI: {}
      }

    case types.B2C_MEMBERSHIP_PAYMENT_UPDATE_RES:
      return {
        ...state,
        paymentUpdateResp: action.payload
      }

    case types.B2C_MEMBERSHIP_PAYMENT_UPDATE_CLEAR:
      return {
        ...state,
        paymentUpdateResp: {}
      }

    case types.PROVIDER_PAYMENT_DETAIL:
      return {
        ...state,
        providerPaymentDetail: action.payload
      }

    case types.PROVIDER_PAYMENT_DETAIL_CLEAR:
      return {
        ...state,
        providerPaymentDetail: {}
      }

    case types.PRODUCT_PAYMENT_DETAIL:
      return {
        ...state,
        productPaymentDetail: action.payload
      }

    case types.PRODUCT_PAYMENT_DETAIL_CLEAR:
      return {
        ...state,
        productPaymentDetail: {}
      }

    case types.MEMBERSHIP_PAYMENT_DETAIL:
      return {
        ...state,
        membershipPaymentDetail: action.payload
      }

    case types.MEMBERSHIP_PAYMENT_DETAIL_CLEAR:
      return {
        ...state,
        membershipPaymentDetail: {}
      }

    case types.FETCH_SUBSCRIBED_DATA_RES:
      return {
        ...state,
        subscribedData: action.payload
      }

    case types.FETCH_SUBSCRIBED_DATA_CLEAR:
      return {
        ...state,
        subscribedData: {}
      }
    case types.VIEW_SUBSCRIPTION_RECEIPT_RES:
      return {
        ...state,
        subscriptionReceipt: action.payload
      }

    case types.VIEW_SUBSCRIPTION_RECEIPT_CLEAR:
      return {
        ...state,
        subscriptionReceipt: {}
      }
    case types.PRE_SUBSCRIPTION_RECEIPT_DATA:
      return {
        ...state,
        preSubscriptionReceiptInfo: action.payload
      }

    case types.PRE_SUBSCRIPTION_RECEIPT_DATA_CLEAR:
      return {
        ...state,
        preSubscriptionReceiptInfo: {}
      }
    case types.CHANGE_SUBSCRIPTION_PLAN_RES:
      return {
        ...state,
        changeSubscriptionPlan: action.payload
      }

    case types.CHANGE_SUBSCRIPTION_PLAN_CLEAR:
      return {
        ...state,
        changeSubscriptionPlan: {}
      }
    case types.FETCH_PRODUCT_PI_RES:
      return {
        ...state,
        fetchProductPI: action.payload
      }

    case types.FETCH_PRODUCT_PI_CLEAR:
      return {
        ...state,
        fetchProductPI: {}
      }

    case types.PROVIDER_CHECKOUT_SUBSCRIPTION_PAGE:
      return {
        ...state,
        providerSubCheckoutPage: action.payload
      }

    case types.PROVIDER_CHECKOUT_SUBSCRIPTION_PAGE_CLEAR:
      return {
        ...state,
        providerSubCheckoutPage: {}
      }
      case types.COACH_OR_SERVICE_ID_RESPONSE:
        return {
          ...state,
          coachOrServiceIdData: action.payload
        }
      case types.COACH_OR_SERVICE_ID_RESPONSE_CLEAR:
        return {
          ...state,
          coachOrServiceIdData: {}
        }
    default:
      return state
  }
}



